import React, { useState } from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Enhance Customer Engagement",
    content:
      "Contact center solutions provide a unified platform to engage with customers across multiple channels, including voice, email, chat, and social media. By providing seamless and personalized communication, businesses can improve customer satisfaction and loyalty.",
  },
  {
    title: "Boost Agent Efficiency",
    content:
      "With features like automated call routing, real-time monitoring, and integrated CRM tools, contact center solutions help agents manage customer inquiries more efficiently. This leads to faster response times, increased productivity, and better service quality.",
  },
  {
    title: "24/7 Availability",
    content:
      "Contact center solutions ensure that your business can operate around the clock. With features such as automated response systems and chatbot integrations, customers can receive support anytime, even outside regular working hours, improving accessibility and customer experience.",
  },
  {
    title: "Data-Driven Insights",
    content:
      "Advanced contact center solutions provide analytics and reporting tools to track performance metrics such as call volume, customer satisfaction, and agent productivity. These insights help businesses make data-driven decisions, improve operational strategies, and optimize resource allocation.",
  },
];

const ContactCenterSolution = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (<>
    <Helmet>
      <meta name="description" content="Boost your business communication with the Best Contact Center Solution Provider in India. Get scalable, AI-powered, and reliable customer support solutions today!"/>
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Best Contact Center Solutions Provider in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/contact-center-solution"/>
<meta property="og:description" content="Boost your business communication with the Best Contact Center Solution Provider in India. Get scalable, AI-powered, and reliable customer support solutions today!"/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Best Contact Center Solutions Provider in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Boost your business communication with the Best Contact Center Solution Provider in India. Get scalable, AI-powered, and reliable customer support solutions today!"/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/contact-center-solution"/>
<title>Best Contact Center Solutions Provider in India | Ayanshtech Solutions</title>
    </Helmet>
    <div className=" flex flex-col items-center justify-center p-6 mb-6">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-4 ">
        <div className="md:w-2/3 space-y-6 p-4">
          <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mt-10">
            Seamless and Smart Contact Center Solutions
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            Harness the power of tailored, scalable contact center solutions
            from Ayanshtech, designed to integrate effortlessly with your
            business systems. Our omnichannel strategy ensures streamlined
            management of all communication channels including voice, video,
            chat, email, and more. By utilizing cutting-edge technology and
            staying ahead of market trends, we create the perfect solution for
            any type of contact center, whether it's inbound, outbound, or a
            combination of both.
          </p>
          <p className="text-gray-700 text-base lg:text-xl">
            In critical scenarios like natural disasters or network disruptions,
            our customized omnichannel solutions automatically reroute calls to
            the appropriate personnel or enable agents to manage communications
            through a mobile app. This ensures uninterrupted operations, even
            during challenging situations.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className=" rounded-3xl">
        <div className="text-center mb-5 mt-5 ">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Contact Center Solution
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            A reliable contact center is essential for businesses to provide
            excellent customer service. Discover the key features of
            Ayanshtech's omnichannel contact center solutions designed to
            enhance your operations.
          </p>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Realtime Agent Monitoring</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">SIP Trunk/Carrier Management</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">DID Management</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Skill-based Routing</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Built-In WebRTC Based Phone</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Level IVRS</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Analytics and Reports</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">ACD Management</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Whisper/Coaching/Barge-in</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Inbound Screen Pop</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Auto Data Retrieval from CRM</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Oncall Campaign Wise Script</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Sticky Agent</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Callback Feature</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Timeclock</p>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center  mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Major Advantages of Contact Center Solutions
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Tailored, scalable, and reliable contact center solutions help
          businesses efficiently manage customer interactions, boost
          satisfaction, and ensure top-notch service delivery. Here are some key
          advantages of contact center solutions:
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/2 ">
            <img
              src="/assets/images/headerSection/contactCenter.jpg"
              alt="Contact Center Solution Provider in India"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Improved productivity</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Enhanced customer service management</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Better security of data</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon20.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Superior customer experience</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">Dynamic scalability</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Real-time monitoring and detailed reports
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-center mb-16 mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Contact Center Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-4 max-w-6xl mx-auto">
            As technology evolves and markets progress, omnichannel contact
            centers have become an essential part of business operations. At
            Ayanshtech, we recognize the unique demands of our clients. Tailored
            to your business requirements and aligned with current market
            trends, we offer customized contact center solutions designed to
            help you reach your goals.
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-7xl mx-auto mb-20 ">
          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <div className="flex items-center space-x-4">
              <div>
                <p className="text-lg">
                  Maintain operational costs while delivering an exceptional
                  customer experience, enabling your business to scale
                  affordably.
                </p>
              </div>
            </div>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6 "
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <div className="flex items-center space-x-4">
              <div>
                <p className="text-lg">
                  Evaluate the performance of your live agents or customer
                  representatives using detailed reports and statistics from the
                  call center software.
                </p>
              </div>
            </div>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <div className="flex items-center space-x-4">
              <div>
                <p className="text-lg">
                  Explore various modules through third-party integrations,
                  helping you select the best solution for both inbound and
                  outbound call centers.
                </p>
              </div>
            </div>
          </div>

          <div
            className="relative flex flex-col space-y-4  rounded-lg p-6"
            style={{
              boxShadow:
                "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
            }}
          >
            <div className="flex items-center space-x-4">
              <div>
                <p className="text-lg">
                  Anticipate potential costs by analyzing trends and patterns
                  from past performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-green-50 p-6 sm:p-8 mb-12 sm:mb-16 rounded-3xl">
        {/* Title Section */}
        <h2 className="text-center text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-6">
          Customized Contact Center Solutions
        </h2>
        <p className="text-center text-base sm:text-lg md:text-xl text-gray-700 mb-8">
          Our Contact Center Solutions are designed to provide seamless
          communication across multiple channels, ensuring a comprehensive
          approach to managing customer interactions. Whether it's voice, chat,
          email, or social media, our solutions integrate everything into one
          platform, empowering your team to deliver consistent, high-quality
          service. With real-time analytics, automated workflows, and
          omnichannel capabilities, our solutions optimize efficiency, enhance
          customer satisfaction, and provide a scalable framework for your
          business to grow.
        </p>

        {/* Navigation Bar */}
        <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
          {pointsData.map((point, index) => (
            <button
              key={index}
              className={`text-base sm:text-lg font-medium ${
                activeIndex === index
                  ? "text-blue-600 underline"
                  : "text-gray-900"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {point.title}
            </button>
          ))}
        </div>

        {/* Content Section */}
        <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
            {pointsData[activeIndex].content}
          </p>
        </div>
      </div>

      <div className="text-center mb-16 mt-5 ">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Why Opt for Ayanshtech’s Contact Center Solution Development?
        </h2>
        <p className="sm:text-base md:text-lg lg:text-lg text-gray-600 mt-4 max-w-6xl mx-auto">
          With over 8 years of expertise in contact center solution development,
          Ayanshtech understands the immense potential in every customer
          interaction. We empower your business to seize these opportunities by
          offering tailored solutions that address your specific needs. Our team
          is adept at building customized omnichannel contact centers that align
          with your business goals.
        </p>
        <p className="sm:text-base md:text-lg lg:text-lg text-gray-600 mt-4 max-w-6xl mx-auto">
          Whether you’re considering migrating your contact center to a
          cloud-based CCaaS solution or seeking a new, state-of-the-art
          solution, our experts are ready to provide guidance and answer all
          your questions.
        </p>
      </div>

      <GetInTouch />
    </div>
  </>);
};

export default ContactCenterSolution;
